// CANONICAL COPY (GH #7115). src/constants/obligations/obl-employee-screening.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-employee-screening',
  title: 'Verify pre-employment screening is performed',
  description:
    'Confirm that all new employees have completed background verification checks before joining. Either a verified evidence record (criminal-record or id-check) or the joiner JML screening-complete checkbox satisfies this obligation.',
  category: 'people',
  scfIds: ['SCF-PPL-001'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'evidence-requirement-met',
      evidenceType: 'criminal-record',
      description: 'Verified, in-date criminal-record evidence for every screened employee',
    },
    {
      type: 'evidence-requirement-met',
      evidenceType: 'id-check',
      description: 'Verified, in-date id-check evidence for every screened employee',
    },
    {
      type: 'employees-screened',
      description: 'Every active employee has screening-complete in a JML joiner checklist',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'employees', label: 'Review Employee Records' }],
};
